module.exports = __webpack_public_path__ + "img/doctores-amables-hombres-mujeres-feliz-equipo-medico-medicos-imagen_132310-2335.41e798bb.png";